import script from "./OperatorApplicationForwardButtonOperator.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationForwardButtonOperator.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationForwardButtonOperator.vue?vue&type=style&index=0&id=7720e973&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7720e973"]])

export default __exports__